import Captcha from '../components/Captcha';
import { ElMessage } from 'element-plus';
const RegPhone = /^1[3456789]\d{9}$/;
const RegResetPass = /^(?![0-9]+$)(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
export default {
  components: {
    Captcha,
    ElMessage
  },
  props: {
    projectInfo: {
      type: Object
    }
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入您的账号'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    const validPhoneNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入您的手机号'));
      } else if (!RegPhone.test(value)) {
        callback(new Error('手机号码格式不正确'));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!RegResetPass.test(value)) {
        callback(new Error('请输入8-16位密码(大小写字母+数字)'));
      } else {
        if (this.resetForm.copyPassword !== '') {
          this.$refs.resetForm.validateField('copyPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.resetForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    const validateUserRealname = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入您的名字'));
      } else {
        callback();
      }
    };
    const validateAgreeCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请先勾选协议'));
      } else {
        callback();
      }
    };
    return {
      /* 表单相关 */
      // 登录
      loginForm: {
        username: '',
        password: ''
      },
      // 注册
      registerForm: {
        userName: '',
        password: '',
        code: '',
        mobile: '',
        orgId: '',
        agreeCheck: true
      },
      // 忘记密码
      resetForm: {
        userName: '',
        phoneNumber: '',
        code: '',
        password: '',
        copyPassword: ''
      },
      // 绑定手机
      bindForm: {
        phoneNumber: '',
        code: ''
      },
      /* 校验相关 */
      // 登录校验
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }]
      },
      // 注册校验
      registerRules: {
        userName: [{
          required: true,
          trigger: 'blur',
          validator: validateUserRealname
        }],
        orgId: [{
          required: true,
          trigger: 'change',
          message: '请选择机构'
        }],
        mobile: [{
          required: true,
          trigger: 'blur',
          validator: validPhoneNumber
        }],
        code: [{
          required: true,
          trigger: 'blur',
          message: '请输入验证码'
        }, {
          min: 4,
          max: 4,
          message: '请输入四位验证码',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePass
        }],
        agreeCheck: [{
          required: true,
          trigger: 'blur',
          validator: validateAgreeCheck
        }]
      },
      // 忘记密码校验
      resetRules: {
        phoneNumber: [{
          required: true,
          trigger: 'blur',
          validator: validPhoneNumber
        }],
        code: [{
          required: true,
          trigger: 'blur',
          message: '请输入验证码'
        }, {
          min: 4,
          max: 4,
          message: '请输入四位验证码',
          trigger: 'blur'
        }],
        password: [{
          validator: validatePass,
          required: true,
          trigger: 'blur'
        }],
        copyPassword: [{
          validator: validatePass2,
          required: true,
          trigger: 'change'
        }]
      },
      // 绑定校验
      bindRules: {
        phoneNumber: [{
          required: true,
          trigger: 'blur',
          validator: validPhoneNumber
        }],
        code: [{
          required: true,
          trigger: 'blur',
          message: '请输入验证码'
        }, {
          min: 4,
          max: 4,
          message: '请输入四位验证码',
          trigger: 'blur'
        }]
      },
      loading: false,
      load: true,
      /* 弹框相关 */
      showResetDialog: false,
      showBindPhoneDialog: false,
      /* 验证码相关 */
      timer: null,
      count: '',
      codeShow: true,
      currType: '0',
      /* tab相关 */
      logInType: '1',
      /* 注册相关 */
      showRegister: false,
      organList: [],
      organId: '',
      agreedPolicy: true,
      organProps: {
        value: 'id',
        label: 'organName',
        checkStrictly: true
      },
      loginText: '工号登录',
      loginInputText: '请输入工号'
    };
  },
  methods: {
    /* 判断是否跳转service 还是 首页 */
    async checkJumpService() {
      // const { roleList } = await this.$store.dispatch("user/getInfo");
      const service = this.$utils.getUrlParams('service');
      console.log('roleList, service :>> ', service);
      if (service) {
        window.open(decodeURIComponent(service), '_self');
      } else {
        window.location.href = '/index.html';
      }
    },
    /* 关闭弹框前清楚操作 */
    beforeClose() {
      this.showResetDialog = false;
      this.showBindPhoneDialog = false;
      this.timer = null;
      this.codeShow = true;
      /* 
        由于绑定手机号需要登录的token去校验是否存在绑定 
        中断绑定手机号后 需要清楚权限相关的数据 token
       */
      this.$utils.delCookie('X-Access-Token');
    },
    /* 图形验证成功 */
    captchaSuccess(res) {
      console.log('captchaSuccess :>> ', res);
      this.sendCode(res);
    },
    /* 点击登录 */
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true;
          let loginParams = {
            ...this.loginForm,
            logInType: +this.logInType
          };
          try {
            const res = await this.$http.getLogin(loginParams, {
              headers: {
                'Content-Type': 'application/json'
              }
            });
            console.log('登录', res);
            if (res.token) this.$utils.setCookie('X-Access-Token', res.token);
            let flag = true;
            if (this.logInType === '2') {
              const res = await this.$http.userBindPhoneInfo();
              console.log('userBindPhoneInfo :>> ', res);
              if (!res) {
                flag = false;
                this.showBindPhoneDialog = true;
              }
            }
            flag && this.checkJumpService();
          } catch (error) {
            console.log('error :>> ', error);
          } finally {
            this.loading = false;
          }
        } else {
          this.loading = false;
          console.log('error submit!!');
          return false;
        }
      });
    },
    /* 智慧树登录 */
    zhsLogin() {
      const host = window.location.protocol + '//' + window.location.host;
      const loginUrl = host + '/login.html';
      const url = host + '/index.html';
      window.location.href = `${host}/alzx/hike-boot/AuthSys/getAuthorize?redirectUri=${url}&failRedirectUri=${loginUrl}`;
    },
    /* 单点登录 */
    unityLogin() {
      window.location.href = this.projectInfo.sso_login_url;
    },
    /* 切换tab */
    async handlerTabs() {
      this.$refs.loginForm.resetFields();
      /* 重载表单 解决火狐兼容问题 */
      this.load = false;
      await this.$nextTick();
      this.load = true;
    },
    /* 完成绑定 */
    async finishBind() {
      const {
        phoneNumber: mobile,
        code
      } = this.bindForm;
      const res = await this.$http.userBindPhone({
        mobile,
        code
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      console.log('data :>> ', res);
      if (res) {
        this.showBindPhoneDialog = false;
        ElMessage.success('绑定成功');
        this.checkJumpService();
      } else {
        ElMessage.error('绑定失败');
      }
    },
    /* 确认重置 */
    async submitInfo() {
      let params1 = {
        code: this.resetForm.code,
        mobile: this.resetForm.phoneNumber
      };
      let params = {
        code: this.resetForm.code,
        mobile: this.resetForm.phoneNumber,
        newPassword: this.resetForm.password
        // username: this.resetForm.phoneNumber
      };

      const res1 = await this.$http.validateCode(params1, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      console.log(res1);
      if (res1 == false) {
        ElMessage({
          message: '您输入的验证码不正确',
          type: 'warning'
        });
        return;
      } else {
        const res = await this.$http.resetPass(params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        console.log('resetPass', res);
        if (res) {
          this.showResetDialog = false;
          ElMessage.success('重置成功，请使用新密码登录');
          // window.location.href = '/login.html'
        }
      }
    },

    /* 确认重置 */
    confirmReset() {
      this.$refs.resetForm.validate(valid => {
        if (valid) {
          this.submitInfo().then(res => {
            console.log(res);
          }).catch(error => {
            ElMessage(error.message);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /* 点击验证码按钮 */
    getCode(phoneNumber, type) {
      /**
       * @param {*} type 0 忘记密码  1 绑定手机号 2 注册
       */
      this.currType = type;
      if (!phoneNumber) {
        ElMessage({
          message: '请先输入您的手机号码',
          type: 'warning'
        });
        return;
      }
      if (RegPhone.test(phoneNumber)) {
        this.$refs.CaptchaEl.show();
      } else {
        ElMessage({
          message: '手机号码格式不正确',
          type: 'warning'
        });
        return;
      }
    },
    /* 验证码接口 */
    async codeMessage({
      randstr: randStr,
      ticket
    }) {
      let params = {};
      if (this.currType == 0) {
        params = {
          mobile: this.resetForm.phoneNumber,
          username: this.resetForm.phoneNumber,
          randStr,
          ticket,
          logInType: 1
        };
      } else if (this.currType == 2) {
        params = {
          mobile: this.registerForm.mobile,
          randStr,
          ticket
        };
      }
      try {
        if (this.currType == 0) {
          const res = await this.$http.sendSmsCode(params);
          console.log('currType == 0', res);
          return Promise.resolve(res);
        } else if (this.currType == 2) {
          const res = await this.$http.sendRegisterCode(params);
          console.log('currType == 2', res);
          return Promise.resolve(res);
        }
      } finally {
        this.timer = null;
        this.codeShow = true;
      }
    },
    /* 绑定手机的验证码接口 */
    async bindCodeMessage({
      randstr: randStr,
      ticket
    }) {
      let params = {
        mobile: this.bindForm.phoneNumber,
        randStr,
        ticket
      };
      try {
        const res = await this.$http.sendRegisterCode(params);
        console.log(res);
        return Promise.resolve(res);
      } finally {
        this.currPhoneNumber = '';
        this.codeShow = true;
      }
    },
    /* 发送验证码 */
    async sendCode(params) {
      console.log('this.currType', this.currType);
      if (this.currType === '1') {
        const res = await this.$http.bindPhoneInfo({
          mobile: this.bindForm.phoneNumber
        }, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        console.log('bindPhoneInfo', res);
        if (!res) {
          ElMessage.error('此手机号已被绑定，请联系管理员');
          return;
        }
      }
      const flag = await (this.currType != '1' ? this.codeMessage : this.bindCodeMessage)(params);
      if (flag) {
        const timeCount = 60;
        if (!this.timer) {
          this.count = timeCount;
          this.codeShow = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= timeCount) {
              this.count--;
            } else {
              this.codeShow = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      } else {
        // this.$message.warning({
        //     message: '发送失败',
        //     type: 'warning'
        // })
      }
    },
    /* 确认注册 */
    confirmRegister() {
      this.$refs.registerForm.validate(async valid => {
        if (valid) {
          let validateParams = {
            code: this.registerForm.code,
            mobile: this.registerForm.mobile
          };
          const res1 = await this.$http.validateBasicCode(validateParams);
          console.log('validateRegisterCode', res1);
          if (res1) {
            if (Array.isArray(this.registerForm.orgId)) {
              this.registerForm.orgId = this.registerForm.orgId.splice(-1, 1)[0];
            }
            const res = await this.$http.confirmRegisterCode({
              ...this.registerForm
            });
            console.log('注册', res);
            if (res) {
              this.registerForm = {};
              this.showRegister = false;
              ElMessage({
                message: '请使用注册手机号登录',
                type: 'success'
              });
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取机构树
    async getOrganList() {
      const data = await this.$http.getCaseOrganTree();
      this.organList = data;
    },
    openRegister() {
      this.getOrganList();
      this.showRegister = true;
    }
  }
};